/* Shared timezone-aware window for cart countdowns and optional gift scheduling. */
(function (root) {
  'use strict';
  function parse(value) {
    const match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!match) return null;
    const [, y, m, d, h, min] = match.map(Number);
    const date = new Date(Date.UTC(y, m - 1, d, h, min));
    if (date.getUTCFullYear() !== y || date.getUTCMonth() !== m - 1 || date.getUTCDate() !== d || h > 23 || min > 59) return null;
    return { year: y, month: m, day: d, hour: h, minute: min };
  }
  function formatter(timeZone) {
    return new Intl.DateTimeFormat('en-US', { timeZone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }
  function fields(timestamp, format) {
    return Object.fromEntries(format.formatToParts(new Date(timestamp)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  }
  function timestamp(value, timeZone) {
    const parts = typeof value === 'string' ? parse(value) : value;
    if (!parts) return null;
    try {
      const format = formatter(timeZone);
      const base = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute);
      let guess = base;
      for (let i = 0; i < 4; i++) {
        const p = fields(guess, format);
        guess = base - (Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - guess);
      }
      const roundTrip = fields(guess, format);
      return Object.keys(parts).every(k => parts[k] === roundTrip[k]) ? guess : null;
    } catch (_) { return null; }
  }
  function windowState(config, now = Date.now()) {
    if (!config?.enabled) return { valid: true, active: true, scheduled: false };
    const start = timestamp(config.start, config.timeZone);
    const end = timestamp(config.end, config.timeZone);
    const valid = start !== null && end !== null && end > start;
    return { valid, active: valid && now >= start && now < end, scheduled: true, start, end };
  }
  const api = { parse, timestamp, windowState };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.JamesOroPromotionWindow = api;
})(typeof window !== 'undefined' ? window : globalThis);
